import React,{useState} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box, Tooltip} from "@material-ui/core";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
    card:{
        height:'5.1rem',
        width:200,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card2:{
        height:'5.1rem',
        width:200,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
       // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
      },
    card3:{
        height:'5.1rem',
        width:190,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card4:{
        height:'5.1rem',
        width:480,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        //marginTop:'-.1rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1rem',
        fontWeight:600
    },
    subtitulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-1.4rem',
        fontSize:'.8rem',
    },
    subtituloCard:{
       // color:'#4a4a4a',
        textAlign:'center',
        marginTop:'.1rem',
        fontSize:'.9rem',
    },
}));


export default function CardPreguntas({listTotal, dtoRegistro}){
    const classes = useStyles();
    const[total,setTotal]= useState([])
    const auxTxt ="¿Conoces a Carlos Zurita?"
    const auxTxt2 ="¿Votarias por El ?"
    const auxTxt3 ="¿Votarías por un Candidato nuevo?"
    const auxTxt4 ="¿Cuál es tu mayor preocupación?"
    const auxColor=process.env.REACT_APP_Fondo_Color
    React.useEffect(()=>{   
        let valor=listTotal         
         if (dtoRegistro.length !== 0 ) {      
            let filtro = listTotal.distritos.filter((distrito)=> distrito.Dto === dtoRegistro.DtId)
            //console.log(filtro[0]);
            valor=filtro[0] 
        }
            
        const Preg03No = valor.Preg03No
        const Preg03Si = valor.Preg03Si
        const Preg01No = valor.Preg01No 
        const Preg01Si = valor.Preg01Si 
        const Preg02No = valor.Preg02No                       
        const Preg02Si = valor.Preg02Si       
        const Preg02Indec = valor.Preg02Indec
        const Preg04Op1 = valor.Preg04Op1        
        const Preg04Op2 = valor.Preg04Op2        
        const Preg04Op3 = valor.Preg04Op3        
        const Preg04Op4 = valor.Preg04Op4        
        const Preg04Op5 = valor.Preg04Op5        
        const Preg04Op6 = valor.Preg04Op6        
        setTotal({
            Preg02Indec:Preg02Indec, Preg03No:Preg03No,
            Preg03Si:Preg03Si, Preg01No:Preg01No, 
            Preg02No:Preg02No, Preg01Si:Preg01Si, Preg02Si:Preg02Si,             
            Preg04Op1: Preg04Op1, Preg04Op2: Preg04Op2,        
            Preg04Op3: Preg04Op3, Preg04Op4: Preg04Op4,        
            Preg04Op5:Preg04Op5, Preg04Op6:Preg04Op6
        })
        
     },[listTotal,dtoRegistro])   

    function generarCards2(mensaje,campo1,campo2, campo3, leyenda){
        return( 
        <CardContent>
            <div  style={{ textAlign:'center',  fontSize:'.8rem', marginBottom:".2rem", marginTop:"-.2rem", 
                display:"flex", flexDirection:"row", justifyContent:"center" }} >        
                
                <Box display={"flex"} flexDirection={"column"} marginRight={"1.2rem"}>
                    <NumberFormat value={campo1} displayType={'text'}  thousandSeparator={true}/>
                    {'Si'}                    
                </Box>
                <Box display={"flex"} flexDirection={"column"} marginRight={"1.2rem"}>
                    <NumberFormat value={campo2} displayType={'text'}  thousandSeparator={true}/>
                    {'Indeciso'}                         
                </Box>     
                <Box display={"flex"} flexDirection={"column"} >
                     <NumberFormat value={campo3} displayType={'text'}  thousandSeparator={true}/>
                     {"No"}
                </Box>
            </div>
            <Tooltip title={leyenda}>
                <p className={classes.subtituloCard} >
                    {mensaje}
                </p>
            </Tooltip>
        </CardContent>
        )
    }
     
    function generarCards3(mensaje,campo1,campo2, campo3, campo4, campo5, campo6, leyenda){
        return( 
        <CardContent>
            <div  style={{ textAlign:'center',  fontSize:'.8rem', marginBottom:".2rem", marginTop:"-.2rem",display:"flex", flexDirection:"row", justifyContent:"center"}} >             
                <Box display={"flex"} flexDirection={"column"} marginRight={"1.2rem"}>
                 <NumberFormat value={campo1} displayType={'text'}  thousandSeparator={true}/>
                    {'Transporte '}         
               </Box>
               <Box display={"flex"} flexDirection={"column"}  marginRight={"1.2rem"}>

                <NumberFormat value={campo2} displayType={'text'}  thousandSeparator={true}/>
                {' Seguridad '}
               </Box>
                <Box display={"flex"} flexDirection={"column"}  marginRight={"1.2rem"}>
                    <NumberFormat value={campo3} displayType={'text'}  thousandSeparator={true}/>
                    {"Economía"} 
                </Box>
                <Box display={"flex"} flexDirection={"column"} marginRight={"1.2rem"}>
                 <NumberFormat value={campo4} displayType={'text'}  thousandSeparator={true}/>
                 {"Basura"}
                </Box>
                <Box display={"flex"} flexDirection={"column"} marginRight={"1.2rem"}>
                     <NumberFormat value={campo5} displayType={'text'}  thousandSeparator={true}/>
                     {"Salud"}
                </Box>                
                <Box display={"flex"} flexDirection={"column"}>
                     <NumberFormat value={campo6} displayType={'text'}  thousandSeparator={true}/>
                     {"Educación"}
                </Box>                
            </div>
            <Tooltip title={leyenda}>
                <p className={classes.subtituloCard} >
                    {mensaje}
                </p>
            </Tooltip>
        </CardContent>
        )
    }

    function generarCards1(mensaje,datGen,datTot, leyenda){
        return( 
        <CardContent>
            <div  style={{ textAlign:'center', fontSize:'.8rem', marginBottom:".2rem", marginTop:"-.2rem",
                 display:"flex", flexDirection:"row", justifyContent:"center" 
            }} > 
                <Box display={"flex"} flexDirection={"column"} marginRight={"1.2rem"}>
                    <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                    {"Si"}                
                </Box>            
                <Box display={"flex"} flexDirection={"column"} >
                    <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>                
                    {'No'}                    
                </Box>
            </div>
            <Tooltip title={leyenda}>
                <p className={classes.subtituloCard} >
                    {mensaje}
                </p>
            </Tooltip>
        </CardContent>
        )
    }

    return (         
    <Box display="flex" flexDirection="row" mb={1}  >   
        <Box display="flex" flexDirection="row">                                    
            <Card className={classes.card}>
                {generarCards1('Pregunta 1',  total.Preg01Si, total.Preg01No, auxTxt)}
            </Card>
            <Card className={classes.card2}>
                {generarCards2('Pregunta 2', total.Preg02Si,  total.Preg02Indec, total.Preg02No, auxTxt2)}
            </Card>
             <Card className={classes.card3}>
                {generarCards1('Pregunta 3', total.Preg03Si ,total.Preg03No, auxTxt3)}
            </Card>
              <Card className={classes.card4}>
                {generarCards3('Pregunta 4', total.Preg04Op1 ,total.Preg04Op2, total.Preg04Op3, total.Preg04Op4, total.Preg04Op5, total.Preg04Op6, auxTxt4)}
            </Card>
        </Box>   
    </Box>
    );
}
 